import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatUnderlinedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_underlined"}/>
}
